import { InjectionKey, Ref } from 'vue';

export const MepInputContainerReference: InjectionKey<Ref<HTMLElement | null>> = Symbol('MepInputContainerReference');

export const MepInputReference: InjectionKey<Ref<HTMLInputElement | null>> = Symbol('MepInputReference');
